import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import { Spinner } from '@/components/ui/spinner';

import { useConversations } from '../api/getConversations';

import { ConversationPreview } from './ConversationPreview';

export const Conversations = () => {
  const useConversationsQuery = useConversations();

  if (useConversationsQuery.isLoading) {
    return <Spinner className="m-auto" />;
  }
  if (useConversationsQuery.error || !useConversationsQuery.data) {
    return (
      <Alert
        variant="destructive"
        className="mx-auto my-4 w-11/12 px-2 lg:mt-8"
      >
        <AlertTitle>Error</AlertTitle>
        <AlertDescription>Failed to load conversations</AlertDescription>
      </Alert>
    );
  }

  return (
    <div className="h-full overflow-y-scroll">
      {useConversationsQuery.data.map((conversation) => (
        <ConversationPreview
          key={conversation.id}
          conversation={conversation}
        />
      ))}
    </div>
  );
};
